module.exports = __webpack_public_path__ + "img/logo-oaib.e1b8b966.svg";